/* ExposureDisplayStatusComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./ExposureDisplayStatusRenderer");
const _ = require("lodash");

function isRow(value) {
    return !_.isNil(value) && !_.isString(value);
}

class ExposureDisplayStatusComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value);
        this._context = context;
        this._statusLabels = _.get(this._context, "statusLabels", {});
        this._value = value;
        this._entity = isRow(value) ? value : undefined;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setExposureStatus(newVal);
        }
        return this;
    }

    getValue() {
        return this.getExposureStatus();
    }

    setExposureStatus(newVal) {
        this._value = newVal;
        if (isRow(newVal)) {
            this._entity = newVal;
        }
        this.emit("ExposureDisplayStatus", this.getDisplayText());
        return this;
    }

    getExposureStatus() {
        return this._value;
    }

    getDisplayText() {
        const value = this._value;
        if (_.isString(value) && value !== "") {
            return _.get(this._statusLabels, value, value);
        }
        const row = this._entity;
        if (!row) {
            return "";
        }
        const display = _.get(row, "exposureDisplayStatus");
        if (!_.isNil(display) && display !== "") {
            return _.get(this._statusLabels, display, display);
        }
        const activity = _.get(row, "exposureActivity");
        if (activity && activity !== "IDLE" && !_.isNil(this._statusLabels[activity])) {
            return this._statusLabels[activity];
        }
        const status = _.get(row, "exposureStatus");
        if (_.isNil(status)) {
            return "";
        }
        return _.get(this._statusLabels, status, status);
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ExposureDisplayStatusComponent;
